module.exports = __webpack_public_path__ + "static/scale-model-of-sidewalk-of-stars-in-memphis-tennessee-a3677493077401bb9bd844b7999b3ecd.png";